document.addEventListener("submit", function(event){
    var target = event.target.closest("#Login");
    if(target) {
        setTimeout(()=>{
            target.reset();
        }, 200);
    }
});